import { Box, Container, Grid, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { getTenantCodeBySubDomain } from "../../../redux/actions/Login/Login";
import { alertMessage } from "../../../redux/actions/SystemIcons/systemIcons";
import { theme } from "../../../redux/actions/Theme/Theme";
import { getWallboardByCode, getWallboardById } from "../../../redux/actions/Wallboard/Wallboard";
import DoughnutChart from "../../charts/dougnut/DoughnutChart";
import HorizontalChartActual from "../../charts/horizontal-chart/HorizontalChartActual";
import VerticalChart from "../../charts/horizontal-chart/VerticalChart";
import LineChart from "../../charts/line/LineChart";
import PieChart from "../../charts/pie/PieChart";
import Breadcrumbs from "../../common2/Breadcrumbs";
import { IPieData } from "./InterfaceWallBoard";
import  ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Slider from "react-slick"; 
import { maxWidth } from "@mui/system";
import { colorPalette } from "../../Theme/Theme";
import { IState } from "../../../redux/reducers/rootReducers";

const ViewChart = () => {
    const param = useParams();
    const dispatch = useDispatch();
    const location = useLocation();
    const [viewVal, setViewVal] = useState<any>(null);
    const [viewValCode, setViewValCode] = useState<any>(null);
    const [wallBoardTypeList, setWallBoardTypeList] = useState<any[]>([]);
    const [chartsInitialized, setChartsInitialized] = useState<boolean>(false);
    const [isDarkMode, setIsDarkMode] = useState<boolean>(false);
    const [tenantCode, setTenantCode] = useState("")
    const CurrLocation = window.location.origin
    const subDomain = window.location.host.split('.')?.[0];
    // const subDomain = "simplisys.vizionsys.com".split('.')?.[0];
    const externalWebLinkLight = `${CurrLocation}/#/ViewChart/${viewVal?.code}?isDarkMode=false`;
    const externalWebLinkDark = `${CurrLocation}/#/ViewChart/${viewVal?.code}?isDarkMode=true`;
    const queryParamMode = new URLSearchParams(location.search).get("isDarkMode");
    const toggleTheme = useSelector((state: IState) => state.theme.theme);
    
    useEffect(() => {
        if (queryParamMode !== null) {
            setIsDarkMode(queryParamMode === "true");
        }
    }, [queryParamMode]);

    useEffect(() => {
        if (queryParamMode === null) {
            const darkTheme = localStorage.getItem('darkTheme');
            if (darkTheme !== null) {
                setIsDarkMode(darkTheme === 'true');
            }
        }
    }, [queryParamMode]);
    
    const priorityName: any = {
        "P1": 409,
        "P2": 88,
        "P3": 60,
        "P4": 9,
    };
    const AgentData: any = {
        "Agent1": 9,
        "Agent2": 3,
        "Agent3": 5,
        "Agent4": 1,
    }
    const ticketStatus: any = {
        "Status1": 36,
        "Status2": 159,
        "Status3": 312,
        "Status4": 12,
    };
    const groupData: any = {
        "1st Line": 1,
        "2nd Line": 2,
        "3rd Line": 3,
        "4th Line": 4,
    }
    const ticketTypes: any = {
        "Type 1": 36,
        "Type 2": 81,
        "Type 3": 65,
        "Type 4": 80,
    }
    const contacts: any = {
        "Conatct 1": 36,
        "Conatct 2": 81,
        "Conatct 3": 65,
        "Conatct 4": 80,
    }
    const division: any = {
        "Division 1": 36,
        "Division 2": 81,
        "Division 3": 65,
        "Division 4": 80,
    }
    const department: any = {
        "Department 1": 36,
        "Department 2": 81,
        "Department 3": 65,
        "Department 4": 80,
    }
    const organisation: any = {
        "Organisation 1": 36,
        "Organisation 2": 81,
        "Organisation 3": 65,
        "Organisation 4": 80,
    }

    useEffect(() => {
        if (param?.code && tenantCode) {

            dispatch(getWallboardByCode(param.code, getWallboardByCodeCB, tenantCode))
        }
        if (param?.id) {
            dispatch(getWallboardById(param.id, getWallboardByIdCB))
        }
    }, [param?.id, tenantCode])
    useEffect(() => {
        if (param?.code) {
            if (subDomain && subDomain !== 'portal' && !subDomain.includes('localhost')) {
                dispatch(getTenantCodeBySubDomain(`${subDomain}`, TenantCodeCB));
            }
        }
    }, [param?.code])

    const TenantCodeCB =(resStatus: string, res: any)=>{
        if (resStatus === "0") {
            setTenantCode(res.tenantcode);
        }
    }
    const getWallboardByIdCB = (resStatus: string, res: any) => {
        // console.log("getWallboardByIdCB", res, resStatus);
        if (resStatus === "0") {
            setViewVal(res);
        }
    };
    const getWallboardByCodeCB = (resStatus: string, res: any) => {
        // console.log("getWallboardByIdCB", res, resStatus);
        if (resStatus === "0") {
            setViewValCode(res);
        }
    };

    useEffect(() => {

        if (viewVal?.wallBoardTypeList && !chartsInitialized) {
            const newWallBoardTypeList = viewVal.wallBoardTypeList.map((i: any) => {
                const { chartType, data,isActive } = i;
                if (!isActive) {
                    return null
                }
                if (chartType && data.datasets[0].label) {
                    let newData;
                    switch (data.datasets[0].label) {
                        case "Group":
                            newData = groupData;
                            break;
                        case "Priority":
                            newData = priorityName;
                            break;
                        case "TicketStatus":
                            newData = ticketStatus;
                            break;
                        case "Agent":
                            newData = AgentData;
                            break;
                        case "TicketType":
                            newData = ticketTypes;
                            break;
                        case "Department":
                            newData = department;
                            break;
                        case "ContactOrganisation":
                            newData = organisation;
                            break;
                        case "Division":
                            newData = division;
                            break;
                        case "Contacts":
                            newData = contacts;
                            break;
                        default:
                            newData = {};
                    }

                    const chart: any = renderChart(chartType, newData, data.datasets[0].label);
                    return { chartType: chartType, data: chart, isActive: true };
                }
                return null;
            })
            setWallBoardTypeList(newWallBoardTypeList);
            setChartsInitialized(true);
        }
    }, [viewVal, chartsInitialized]);

    const extractData = (dataObject: any, value: any) => {
        if (dataObject && dataObject[value]) {
            return [dataObject[value].dataList, dataObject[value].count]
        }
        return [];
    };
    useEffect(() => {
        if (viewValCode?.wallBoardTypeList && !chartsInitialized) {
            const newWallBoardTypeList = viewValCode.wallBoardTypeList.map((i: any) => {
                const { chartType, value ,isActive} = i;
                if (!isActive) {
                    return null
                }
                if (chartType && value) {
                    const newData = extractData(i.wallboardData, value)

                    const chart = renderChart(chartType, newData[0], value);
                    return { chartType: chartType, data: chart, count: newData[1], isActive: true };
                }
                return null;
            })

            setWallBoardTypeList(newWallBoardTypeList);
            setChartsInitialized(true);
            
        }
    }, [viewValCode, chartsInitialized]);

    const renderChart = (type: any, data: any, property: string = "") => {
        const labels = Object.keys(data);
        const values = Object.values(data);
        const chartData: IPieData = {
            labels: labels,
            chartType: type,
            datasets: [
                {
                    label: property,
                    data: values,
                    backgroundColor: colorPalette,
                    borderColor: colorPalette,
                    borderWidth: 1,
                },
            ],
        };
        return chartData;
    }
    const ChartItem = useMemo(() => {
        const activeItems = wallBoardTypeList.filter(chartComponent => chartComponent?.isActive);
        const itemsToShow = activeItems.slice(0, 9);
        const getColNum = () => {
            if (itemsToShow.length === 1) {
                return 12;
            } else if (itemsToShow.length === 2 || itemsToShow.length === 3 || itemsToShow.length === 4 ) {
                return 6;
            }else if (itemsToShow.length === 5 || itemsToShow.length === 6 || itemsToShow.length === 7 || itemsToShow.length === 8 || itemsToShow.length === 9) {
                return 4;
            } else {
                return 12;
            }
        }
    
        return itemsToShow.map((chartComponent, index) => {
            const col = getColNum();
                let chartHeight;
                if (itemsToShow.length === 1 || itemsToShow.length === 2) {
                    chartHeight = 400;
                } else if (itemsToShow.length === 3 || itemsToShow.length === 4 || itemsToShow.length === 5 || itemsToShow.length === 6) {
                    chartHeight = 300;
                } else {
                    chartHeight = 280;
                }
            return (
                <Grid item md={col} key={index} 
                style={{  height: chartHeight }}
                >
                    {viewValCode && (
                        <div
                            style={{
                                textAlign: 'center',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                color: isDarkMode ? 'white' : 'black',
                            }}
                        >
                            Count: {chartComponent.count}
                        </div>
                    )}
                    {(() => {
                        switch (chartComponent?.chartType) {
                            case "VerticalBarGraph":
                                return <VerticalChart label={chartComponent?.data?.labels} dataSets={chartComponent.data.datasets} showLabels={false} isDarkMode={isDarkMode}/>;
                            case "HorizontalBarGraph":
                                return <HorizontalChartActual label={chartComponent?.data?.labels} dataSets={chartComponent.data.datasets} showLabels={false} isDarkMode={isDarkMode}/>;
                            case "LineGraph":
                                return <LineChart datasets={chartComponent.data.datasets} labels={chartComponent?.data?.labels} showLabels={false} isDarkMode={isDarkMode}/>;
                            case "PieGraph":
                                return <PieChart labels={chartComponent?.data?.labels} datasets={chartComponent.data.datasets} showLabels={false} isDarkMode={isDarkMode}/>;
                            case "DoughnutGraph":
                                return <DoughnutChart labels={chartComponent?.data?.labels} datasets={chartComponent.data.datasets} showLabels={false} isDarkMode={isDarkMode}/>;
                            default:
                                return <>Choose dropdowns to render chart!</>;
                        }
                    })()}
                </Grid>
            );
        });
    }, [wallBoardTypeList, viewValCode,isDarkMode]);
    

    // const ChartItemByCode = useMemo(() => {
    //     const activeItems = wallBoardTypeList.filter(chartComponent => chartComponent?.isActive);
    //     const itemsToShow = activeItems.slice(0, 9); 
    //     const sliderSettings = {
    //         dots: false,
    //         arrows: false,
    //         infinite: true,
    //         autoplay: true,
    //         autoplaySpeed: 5000, 
    //         speed: 500,
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //     };
    
    //     const renderChart = (chartComponent:any) => {
    //         switch (chartComponent?.chartType) {
    //             case "VerticalBarGraph":
    //                 return <VerticalChart label={chartComponent?.data?.labels} dataSets={chartComponent.data.datasets} showLabels={false} isDarkMode={isDarkMode} />;
    //             case "HorizontalBarGraph":
    //                 return <HorizontalChartActual label={chartComponent?.data?.labels} dataSets={chartComponent.data.datasets} showLabels={false} isDarkMode={isDarkMode} />;
    //             case "LineGraph":
    //                 return <LineChart datasets={chartComponent.data.datasets} labels={chartComponent?.data?.labels} showLabels={false} isDarkMode={isDarkMode} />;
    //             case "PieGraph":
    //                 return <PieChart labels={chartComponent?.data?.labels} datasets={chartComponent.data.datasets} showLabels={false} isDarkMode={isDarkMode} />;
    //             case "DoughnutGraph":
    //                 return <DoughnutChart labels={chartComponent?.data?.labels} datasets={chartComponent.data.datasets} showLabels={false} isDarkMode={isDarkMode} />;
    //             default:
    //                 return <>Choose dropdowns to render chart!</>;
    //         }
    //     };
    
    //     return (
    //         <div style={{ display: "flex", flexDirection: "column", height: "100vh", overflow: "hidden" }}>
    //             {/* Slider for All Charts */}
    //             {itemsToShow.length > 0 && (
    //                 <div
    //                     style={{
    //                         flexShrink: 0,
    //                         background: isDarkMode ? "#222" : "#fff",
    //                         padding: "10px 0",
    //                     }}
    //                 >
    //                     <Slider {...sliderSettings}>
    //                         {itemsToShow.map((chartComponent, index) => (
    //                             <div key={index} style={{ padding: 10 }}>
    //                                 <div
    //                                     style={{
    //                                         width: "90%",
    //                                         height: "250px",
    //                                         margin: "auto",
    //                                         background: isDarkMode ? "#444" : "#efefef",
    //                                         borderRadius: "8px",
    //                                         display: "flex",
    //                                         flexDirection: "column",
    //                                         alignItems: "center",
    //                                         justifyContent: "center",
    //                                     }}
    //                                 >
    //                                     <div
    //                                         style={{
    //                                             textAlign: "center",
    //                                             fontSize: "14px",
    //                                             fontWeight: "bold",
    //                                             color: isDarkMode ? "white" : "black",
    //                                         }}
    //                                     >
    //                                         Count: {chartComponent.count}
    //                                     </div>
    //                                     <div style={{ flex: 1, width: "100%" }}>
    //                                         {renderChart(chartComponent)}
    //                                     </div>
    //                                 </div>
    //                             </div>
    //                         ))}
    //                     </Slider>
    //                 </div>
    //             )}
    //         </div>
    //     );
    // }, [wallBoardTypeList, isDarkMode]);
        
    
    const ChartItemByCode = useMemo(() => {
        const activeItems = wallBoardTypeList.filter(chartComponent => chartComponent?.isActive);
        const itemsToShow = activeItems.slice(0, 9); 
        const sliderSettings = {
            dots: false,
            arrows: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
        };
    
        const renderChart = (chartComponent: any) => {
            if (!chartComponent) return <>No chart available to display!</>;
    
            switch (chartComponent?.chartType) {
                case "VerticalBarGraph":
                    return <VerticalChart label={chartComponent?.data?.labels} dataSets={chartComponent.data.datasets} chartLabel={chartComponent.data.datasets[0].label} showLabels={true} isDarkMode={isDarkMode} />;
                case "HorizontalBarGraph":
                    return <HorizontalChartActual label={chartComponent?.data?.labels} dataSets={chartComponent.data.datasets} chartLabel={chartComponent.data.datasets[0].label} showLabels={true} isDarkMode={isDarkMode} />;
                case "LineGraph":
                    return <LineChart datasets={chartComponent.data.datasets} labels={chartComponent?.data?.labels} chartLabel={chartComponent.data.datasets[0].label} showLabels={true} isDarkMode={isDarkMode} />;
                case "PieGraph":
                    return <PieChart labels={chartComponent?.data?.labels} datasets={chartComponent.data.datasets} chartLabel={chartComponent.data.datasets[0].label} showLabels={true} isDarkMode={isDarkMode} />;
                case "DoughnutGraph":
                    return <DoughnutChart labels={chartComponent?.data?.labels} datasets={chartComponent.data.datasets} chartLabel={chartComponent.data.datasets[0].label} showLabels={true} isDarkMode={isDarkMode} />;
                default:
                    return <>No valid chart type found!</>;
            }
        };
    
        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100vh", // Full-screen height
                    width: "100vw", // Full-screen width
                    overflow: "hidden", // Prevent unwanted scrollbars
                    backgroundColor: isDarkMode ? "#333" : "#fff",
                }}
            >
                {itemsToShow.length > 0 ? (
                    <Slider {...sliderSettings}>
                        {itemsToShow.map((chartComponent, index) => (
                            <div
                                key={index}
                                style={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "20px",
                                }}
                            >
                                <div
                                    style={{
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: isDarkMode ? "#444" : "#efefef",
                                        borderRadius: "8px",
                                    }}
                                >
                                    <div
                                        style={{
                                            textAlign: "center",
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                            color: isDarkMode ? "white" : "black",
                                            marginBottom: "10px",
                                        }}
                                    >
                                        Count: {chartComponent.count}
                                    </div>
                                    <div style={{
                                            height:"700px"
                                        }} >
                                        {renderChart(chartComponent)}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                ) : (
                    <Typography variant="h6" color="textSecondary">
                        No active charts available.
                    </Typography>
                )}
            </div>
        );
    }, [wallBoardTypeList, isDarkMode]);
    
    


    const handleCopyLink = (mode: "light" | "dark") => (e: React.MouseEvent) => {
        e.preventDefault();
        const linkToCopy = mode === "light" ? externalWebLinkLight : externalWebLinkDark;
        
        navigator.clipboard.writeText(linkToCopy)
            .then(() => {
                const message = `Success! ${mode === "light" ? "Light" : "Dark"} Mode WallBoard Link Copied`;
                dispatch(alertMessage(message, "success"));
            })
            .catch((err) => {
                const error = `Failed to Copy ${mode === "light" ? "Light" : "Dark"} Mode WallBoard Link`;
                dispatch(alertMessage(error, "error"));
                console.error('Failed to copy link: ', err);
            });
    };
    useEffect(()=>{
        dispatch(theme(isDarkMode));
    },[isDarkMode])
    return (
        <>
            <div className="white-bg container-fill-screen">
                <div>
                    {param.id &&
                        <Breadcrumbs
                            data={[
                                {
                                    title: 'Reports Management ',
                                    path: '/ReportsManagement'
                                },
                                {
                                    title: 'WallBoard',
                                    path: '/WallBoard'
                                },
                                {
                                    title: `View Wallboard`,
                                    path: `${"/ViewChart/" + param.id}`
                                }
                            ]}
                        />
                    }
                </div>
                {viewVal && (
                    <div style={{ marginTop: '25px', marginLeft: '25px' }}>
                        <Typography >
                            <>
                                <p style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                    Copy External WallBoard Link here Light Mode
                                    <a href="#">
                                        <ContentCopyIcon className="WallBoard-Link" onClick={handleCopyLink("light")} style={{ padding: "3px" }} />
                                    </a>
                                </p>
                                <p style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                    Dark Mode
                                    <a href="#">
                                        <ContentCopyIcon className="WallBoard-Link" onClick={handleCopyLink("dark")} style={{ padding: "3px" }} />
                                    </a>
                                </p>
                            </>
                        </Typography>
                    </div>
                )}

                <Container className="white-bg" style={{maxWidth:"none"}}>
                    <Box className="white-bg container-fill-screen" >
                        <Box className="white-bg">
                            <Typography>
                                {viewVal ? <b>WallBoard - {viewVal?.name}</b> : <b>WallBoard - {viewValCode?.name}</b>}
                            </Typography>
                            <Grid
                                container
                                spacing={1}
                                alignItems={"stretch"}
                                style={{
                                    marginTop:"15px"
                                }}
                            >
                                {viewVal ? ChartItem:ChartItemByCode}
                                {/* {ChartItem} */}
                            </Grid>

                        </Box>
                    </Box>
                </Container>
            </div>

        </>
    );
};

export default ViewChart;
